import { styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  MainBox: 'MainBox',
  ActionIcons: 'ActionIcons',
  accuracyDetailsAgGridStyle: 'accuracyDetailsAgGridStyle',
  documentRowMainBox: 'documentRowMainBox',
  documentNameBox: 'documentNameBox',
  documentRowTypography: 'documentRowTypography',
  documentRowTypographyColor: 'documentRowTypographyColor',
  editIconBox: 'editIconBox',
  editIcon: 'editIcon',
  documentEditCellBox: 'documentEditCellBox',
  editCellTextfield: 'editCellTextfield',
  editCellActionIcons: 'editCellActionIcons',
  dateValueBox: 'dateValueBox',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.MainBox}`]: {
    height: `calc(100vh - ${theme.spacing(6)})`,
    [up('xs')]: {
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.ActionIcons}`]: {
    marginRight: '2vw',
    marginTop: '9px',
    cursor: 'pointer',
    [up('xs')]: {
      width: '12',
      height: '12px',
    },
    [up('sm')]: {
      width: '14',
      height: '14px',
    },
    [up('md')]: {
      width: '16',
      height: '16px',
    },
    [up('lg')]: {
      width: '18',
      height: '18px',
    },
    [up('xl')]: {
      width: '20',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22',
      height: '22px',
    },
  },

  [`& .${classes.documentRowMainBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.documentNameBox}`]: {
    [up('xs')]: {
      width: '14vw',
      marginRight: '2vw',
    },
    [up('sm')]: {
      width: '41vw',
      marginRight: '2vw',
    },
    [up('md')]: {
      width: '30vw',
      marginRight: '2vw',
    },
    [up('lg')]: {
      width: '20vw',
      marginRight: '2vw',
    },
    [up('xl')]: {
      width: '19vw',
      marginRight: '2vw',
    },
    [up('xxl')]: {
      width: '14vw',
      marginRight: '2vw',
    },
  },
  [`& .${classes.documentRowTypography}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  [`& .${classes.documentRowTypographyColor}`]: {
    color: theme.palette.lunarBase.main,
  },
  [`& .${classes.editIconBox}`]: {
    marginTop: '9px',
  },
  [`& .${classes.editIcon}`]: {
    cursor: 'pointer',
    fontSize: '10px',
    [up('xs')]: {
      width: '12px',
      height: '12px',
    },
    [up('sm')]: {
      width: '14px',
      height: '14px',
    },
    [up('md')]: {
      width: '16px',
      height: '16px',
    },
    [up('lg')]: {
      width: '10px',
      height: '10px',
    },
    [up('xl')]: {
      width: '20px',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22px',
      height: '22px',
    },
  },
  [`& .${classes.accuracyDetailsAgGridStyle}`]: {
    [up('xs')]: {
      height: '55vh',
    },
    [up('sm')]: {
      height: '68vh',
    },
    [up('md')]: {
      height: '67vh',
    },
    [up('lg')]: {
      height: '70vh',
    },
    [up('xl')]: {
      height: '77vh',
    },
    [up('xxl')]: {
      height: '77.8vh',
    },
  },
  [`& .${classes.documentEditCellBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.editCellTextfield}`]: {
    '& fieldset': {
      border: 'none',
      borderRadius: '5px',
      backgroundColor: theme.palette.secondaryWhite.semiDark,
    },
    '& .MuiInputBase-input:hover + fieldset': {
      border: 'none !important',
    },
    '& .MuiInputBase-input:focus + fieldset': {
      border: 'none !important',
    },
    [up('xs')]: {
      width: '18vw',
    },
    [up('sm')]: {
      width: '45vw',
    },
    [up('md')]: {
      width: '34vw',
    },
    [up('lg')]: {
      width: '24vw',
    },
    [up('xl')]: {
      width: '23vw',
    },
    [up('xxl')]: {
      width: '18vw',
    },
  },
  [`& .${classes.editCellActionIcons}`]: {
    padding: '0px, 10px',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.dateValueBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
